import {
    createCommentVNode as _$ccv,
    createUnknownComponentVNode as _$cc,
    createElementVNode as _$ce,
    createTextVNode as _$ct,
    createVNode as _$cv,
    className as _$cn,
    map as _$ma,
} from 'intact';
import {getRestProps, mapChildren} from '../utils';
import {ButtonGroup, Button} from '../button';
import {Select, Option} from '../select';
import {Input} from '../input';
import {Icon} from '../icon';
import {_$} from '../../i18n';
import {makeStyles} from './styles';

var _$tmp0 = {
    'className': 'ion-ios-arrow-left'
};
var _$tmp1 = {
    'className': 'ion-ios-arrow-right'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {
        total, size, noBorder, simple, 
        className, showTotal, showGoto,
        counts, value, limit, limits,
        showLimits
    } = this.get();
    
    if (!total) return _$ccv(' pagination ')
    
    const classNameObj = {
        'k-pagination': true,
        [className]: className,
        [`k-${size}`]: size !== 'default',
        ['k-no-border']: noBorder,
        ['k-simple']: simple,
        [makeStyles()]: true,
    };
    
    let type = 'default';
    if (noBorder || simple) {
        type = 'none';
    }
    
    const totalPages = (Math.ceil(total / limit)) || 0;
    
    const paginationButton = function(page) {
        return (
            _$cc(Button, {
                'type': type,
                'size': size,
                'icon': true,
                'value': page,
                'children': page
            })
        );
    };
    
    const paginationDot = function(callback) {
        return _$cc(Button, {
            'type': type,
            'size': size,
            'icon': true,
            'className': 'k-pagination-ellipsis',
            'ev-click': callback,
            'children': '...'
        })
    };
    
    let paginationItems = [];
    let minCount = Math.ceil(counts / 2);
    let maxCount = totalPages - minCount;
    let prevPage = value - 1;
    let nextPage = value + 1;
    
     if (!simple) {
        if (totalPages > counts) {
            if (value <= minCount) {
                const max = counts - 2;
                for (let i = 1; i <= max; i++) {
                    paginationItems.push(paginationButton(i));
                }
                paginationItems.push(paginationDot(this.fastNext));
                paginationItems.push(paginationButton(totalPages));
            } else if (value > minCount && value <= maxCount) {
                paginationItems.push(paginationButton(1));
                paginationItems.push(paginationDot(this.fastPrev));
    
                const midCount = counts - 4;
                const mid = Math.floor(midCount / 2);
                const min = value - mid;
                const max = midCount % 2 === 1 ? value + mid : value + mid - 1;
                for (let i = min; i <= max; i++) {
                    paginationItems.push(paginationButton(i));
                }
    
                paginationItems.push(paginationDot(this.fastNext));
                paginationItems.push(paginationButton(totalPages));
            } else {
                paginationItems.push(paginationButton(1));
                paginationItems.push(paginationDot(this.fastPrev));
    
                const min = totalPages - counts + 3;
                for (let i = min; i <= totalPages; i++) {
                    paginationItems.push(paginationButton(i));
                }
            }
        } else {
            for (let i = 1; i <= totalPages; i++) {
                paginationItems.push(paginationButton(i));
            }
        }
    } else {
        paginationItems = [
            _$cc(Input, {
                'size': size === 'mini' || size === 'small' ? 'mini' : 'small',
                'autoWidth': true,
                'value': value,
                'ev-change': this.goto
            }),
            _$ce(2, 'span', [
                _$ct(' / '),
                totalPages
            ], 0, 'k-pagination-text'),
        ];
    }
    
    return _$cv('div', {
        'className': _$cn(classNameObj),
        ...getRestProps(this)
    }, [
        _$cc(ButtonGroup, {
            'checkType': 'radio',
            'children': [
                _$cc(Button, {
                    'icon': true,
                    'size': size,
                    'type': type,
                    'disabled': value <= 1,
                    'ev-click': this.prev,
                    'children': (
                        _$cc(Icon, _$tmp0)
                    )
                }),
                paginationItems,
                _$cc(Button, {
                    'icon': true,
                    'size': size,
                    'type': type,
                    'disabled': value >= totalPages,
                    'ev-click': this.next,
                    'children': (
                        _$cc(Icon, _$tmp1)
                    )
                })
            ],
            'ev-$model:value': function($v) {
                $this.set('value', $v);
            },
            'value': $this.get('value')
        }),
        (!simple) ?
            [
                (showLimits) ?
                    _$ce(2, 'div', (
                        _$cc(Select, {
                            'size': size,
                            'children': (
                                _$ma(limits, function($value, $key) {
                                    return _$cc(Option, {
                                        'value': $value,
                                        'children': _$('{n} 条 / 页', {n: $value})
                                    });
                                }, $this)
                            ),
                            'ev-$model:value': function($v) {
                                $this.set('limit', $v);
                            },
                            'value': $this.get('limit')
                        })
                    ), 2, 'k-pagination-limits') :
                    undefined,
                (showGoto) ?
                    _$ce(2, 'div', [
                        _$ce(2, 'span', _$('跳至'), 0, 'c-middle'),
                        _$cc(Input, {
                            'size': size,
                            'value': value,
                            'ev-change': this.goto
                        }),
                        _$ce(2, 'span', _$('页'), 0, 'c-middle')
                    ], 4, 'k-pagination-goto') :
                    undefined,
                (showTotal) ?
                    _$ce(2, 'div', _$('共 {n} 条', {n: total}), 0, 'k-pagination-total') :
                    undefined
            ] :
            undefined
    ]);
};